<template>
  <div>
    <div class="Home">
      Home page
    </div>
  </div>
</template>

<script>
export default {
  name: "homePage",
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL,
      products: []
    };
  }
};
</script>
